/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_Th_PurposeInputs */

const tr_cerez_s3_th_purpose = /** @type {(inputs: Cerez_S3_Th_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amaç`)
};

const en_cerez_s3_th_purpose = /** @type {(inputs: Cerez_S3_Th_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purpose`)
};

const de_cerez_s3_th_purpose = /** @type {(inputs: Cerez_S3_Th_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweck`)
};

const ru_cerez_s3_th_purpose = /** @type {(inputs: Cerez_S3_Th_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назначение`)
};

/**
* | output |
* | --- |
* | "Purpose" |
*
* @param {Cerez_S3_Th_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_th_purpose = /** @type {((inputs?: Cerez_S3_Th_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_Th_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_th_purpose(inputs)
	if (locale === "de") return de_cerez_s3_th_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_th_purpose(inputs)
	return tr_cerez_s3_th_purpose(inputs)
});